"use client";
import { useEffect, useState } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import {
  ContainedButton,
  CTextButton,
  CTextField,
  CTypography,
} from "./CustomStyles";
import { Poppins } from "next/font/google";
import axios from "axios";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import { useRouter } from "next/navigation";
import { jwtDecode } from "jwt-decode";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const ResendTypographyStyles = {
  fontSize: "14px",
  fontWeight: 500,
  textAlign: "center",
  fontFamily: poppins.style.fontFamily,
  color: "#33415C !important",
  "& .timer": { color: "#004FE0" },
};

const ContinueButtonStyle = {
  padding: "16px",
  borderRadius: "10px",
};

const ConfirmationOTP = (props) => {
  const {
    email,
    phone,
    password,
    signInWith,
    handleClose,
    setAuthSteps,
    setAuthState,
    invite_token,
    changingToken,
    handleSubmitFn,
    invitationFrom,
    phoneFormatted,
    initializeAgain,
    setChangingToken,
    forgotPasswordMode,
    showToastWithMessage,
    setForgotPasswordMode,
  } = props;

  const router = useRouter();

  const [timer, setTimer] = useState(30);
  const [isOtp, setIsOtp] = useState("");
  const [countdown, setCountdown] = useState(30);
  const [otpError, setOtpError] = useState(false);
  const [isTimerOn, setIsTimerOn] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [isResendButtonHidden, setIsResendButtonHidden] = useState(false);

  const [errorStatus, setErrorStatus] = useState(false);

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  // * === countdown === * //
  useEffect(() => {
    let interval = null;
    if (isTimerOn && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsTimerOn(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isTimerOn, timer]);

  const handleResendCode = () => {
    // setTimer(30);
    // setIsTimerOn(true);
    // === Api call here === //

    setIsResendButtonHidden(true);
    setCountdown(30);
    resendOtpCode();
  };

  useEffect(() => {
    let timer;

    if (isResendButtonHidden && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsResendButtonHidden(false);
    }

    return () => clearInterval(timer);
  }, [isResendButtonHidden, countdown]);

  const handleOnSubmit = () => {
    if (isOtp !== "") {
      // === Api call here === //
    } else {
      setOtpError(true);
    }
  };

  const resendOtpForMobile = () => {
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["phone"] = `${phone}`;
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";
        console.log(postData);

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendPhoneForLoginSignup`, postData)
          .then((response) => {
            setShowLoader(false);
            showToastWithMessage("Code sent");
            setAuthSteps(2);
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const resendOtpForEmail = () => {
    if (password.length == 0) {
      setPasswordError("Password is required");
      setShowLoader(false);
      return false;
    }
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["password"] = password;
        postData["user_role"] = "student";
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForNewEmail`, postData)
          .then((response) => {
            console.log(response?.data, "response");
            setShowLoader(false);
            if (!response?.data?.error) {
              showToastWithMessage("Code sent");
              setAuthSteps(2);
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const sendOtpForMobile = async () => {
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["phone"] = `${phone}`;
        postData["otp"] = isOtp;
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";
        console.log(postData);

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendOtpForLoginSignup`, postData)
          .then((response) => {
            setShowLoader(false);
            if (!response?.data?.old_account) {
              setAuthSteps(6);
            } else if (response?.data?.old_account) {
              console.log("hide the drawer");
              if (response?.data?.error) {
                setAlertSeverity("error");
                setAlertMessage("Sign in failed, Phone, otp incorrect");
                setAlertOpen(true);
              } else {
                const userData = {
                  id: response?.data?.body?.id,
                  firstName: response?.data?.body?.firstName,
                  lastName: response?.data?.body?.lastName,
                  email: response?.data?.body?.email,
                  phone_number: response?.data?.body?.phone_number,
                  image: response?.data?.body?.image,
                  userRole: response?.data?.body?.userRole,
                };
                setErrorStatus(false);

                // set user data and user access token
                localStorage.setItem("userData", JSON.stringify(userData));
                localStorage.setItem("userToken", response?.data?.token);

                // set user as authorized
                localStorage.setItem("userAuthenticated", true);
                const userVerified =
                  response?.data?.body?.email_verified_at?.length == 0
                    ? false
                    : true;
                localStorage.setItem("userVerified", userVerified);

                // show success message
                setAlertSeverity("success");
                setAlertMessage("Sign in Success!");
                setAlertOpen(true);

                localStorage.setItem(
                  "profile_completed",
                  response?.data?.profile_completed
                );
                setAuthState(false);

                // console.log(props.organization_invitation, 345);
                if (props.organization_invitation) {
                  localStorage.setItem("invite_token", props.invite_token);
                  router.push("/create-new-teaching-account");
                } else {
                  initializeAgain();
                }
              }
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const sendOtpForEmail = () => {
    let postData = {};
    let fromBecomeATeacher = sessionStorage.getItem("from_become_a_teacher")
    fromBecomeATeacher = fromBecomeATeacher ? Boolean(fromBecomeATeacher) : false 
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["from_become_a_teacher"] = fromBecomeATeacher;
        postData["otp"] = isOtp;
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";
        console.log(postData);

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitVerificationCodeForEmail`, postData)
          .then((response) => {
            setShowLoader(false);
            if (response?.data?.error) {
              setAlertSeverity("error");
              setAlertMessage("Sign in failed, Email, password incorrect");
              setAlertOpen(true);
            } else {
              const userData = {
                id: response?.data?.body?.id,
                firstName: response?.data?.body?.first_name,
                lastName: response?.data?.body?.last_name,
                email: response?.data?.body?.email,
                phone_number: response?.data?.body?.phone_number,
                image: response?.data?.body?.image,
                userRole: response?.data?.body?.user_role,
                from_become_a_teacher : response?.data?.body?.from_become_a_teacher
              };
              setErrorStatus(false);
              sessionStorage.removeItem("from_become_a_teacher");

              const decoded = jwtDecode(response?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);

              // set user data and user access token
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("userToken", response?.data?.token);
              localStorage.setItem("jwtToken", response?.data?.jwt_token);


              // set user as authorized
              localStorage.setItem("userAuthenticated", true);
              const userVerified =
                response?.data?.body?.email_verified_at?.length == 0
                  ? false
                  : true;
              localStorage.setItem("userVerified", userVerified);

              // show success message
              setAlertSeverity("success");
              setAlertMessage("Sign in Success!");
              setAlertOpen(true);

              localStorage.setItem(
                "profile_completed",
                response?.data?.profile_completed
              );
              
              if (props.organization_invitation) {
                localStorage.setItem("invite_token", props.invite_token);
                router.push("/create-new-teaching-account");
              } else {
                initializeAgain();
              }
              router.push("/onboarding");
              setAuthState(false);
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const sendOtpForForgotPasswordEmail = () => {
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["otp"] = isOtp;
        postData["token"] = token;

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitVerificationCodeForForgotEmail`, postData)
          .then((response) => {
            setShowLoader(false);
            if (!response?.data?.error) {
              setChangingToken(response?.data?.changing_token);
              setAuthSteps(4);
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const sendOtpForForgotPasswordPhone = () => {};

  const resendOtpForForgotPasswordEmail = () => {
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["token"] = token;

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendEmailForForgetPassword`, postData)
          .then((response) => {
            setShowLoader(false);
            showToastWithMessage("Code sent");
          })
          .catch((err) => {
            console.log(err);
            setShowLoader(false);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const resendOtpForForgotPasswordPhone = () => {};

  const continueHandler = () => {
    if (isOtp !== "") {
      // === Api call here === //
    } else {
      setErrorMessage("Required");
      setOtpError(true);
      return false;
    }

    setShowLoader(true);
    if (signInWith == "email") {
      if (forgotPasswordMode) {
        sendOtpForForgotPasswordEmail();
      } else {
        sendOtpForEmail();
      }
    } else {
      if (forgotPasswordMode) {
        sendOtpForForgotPasswordPhone();
      } else {
        sendOtpForMobile();
      }
    }
  };

  const resendOtpCode = async () => {
    console.log(signInWith, "signInWith");
    setShowLoader(true);
    if (signInWith == "email") {
      if (forgotPasswordMode) {
        resendOtpForForgotPasswordEmail();
      } else {
        resendOtpForEmail();
      }
    } else {
      if (forgotPasswordMode) {
        resendOtpForForgotPasswordPhone();
      } else {
        resendOtpForMobile();
      }
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "32px" }}>
        <CTypography>
          To confirm your account, please enter the code we sent to:&nbsp;
          <span style={{ fontWeight: 600 }}>
            {signInWith == "email" ? email : phoneFormatted}
          </span>
        </CTypography>

        <CTextField
          placeholder="6-digit code"
          sx={{ marginTop: "-8px" }}
          value={isOtp}
          onChange={(e) => {
            setErrorMessage("");
            setIsOtp(e.target.value);
          }}
          error={errorMessage != ""}
          helperText={errorMessage != "" ? errorMessage : ""}
        />
        {/* // * === Resend code part end === * // */}
        <ContainedButton
          variant="contained"
          onClick={(e) => continueHandler()}
          endIcon={<ArrowForwardRoundedIcon />}
          // onClick={() => {
          //   handleOnSubmit();
          //   handleConfirm();
          // }}
          // onClick={handleSubmitFn}
        >
          {!forgotPasswordMode ? `Next` : `Continue`}
        </ContainedButton>
        {/* // * === Resend code part start === * // */}
        <Box sx={{ mt: "-12px", fontFamily: poppins.style.fontFamily }}>
          {isTimerOn ? (
            <Typography sx={ResendTypographyStyles}>
              Haven’t received code yet? Resend Code&nbsp;
              <span className="timer">
                ({`00:${timer.toString().padStart(2, "0")}`})
              </span>
            </Typography>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "center",
                fontFamily: poppins.style.fontFamily,
              }}
              className="OTPSendButton"
            >
              <Typography
                sx={{
                  display: "inline",
                  fontFamily: poppins.style.fontFamily,
                  color: "#33415C !important",
                }}
              >
                Haven’t received code yet?
              </Typography>
              <CTextButton
                variant="text"
                onClick={
                  isResendButtonHidden
                    ? console.log("it is disabled")
                    : handleResendCode
                }
                disabled={isTimerOn}
                sx={{
                  p: 0,
                  fontFamily: poppins.style.fontFamily,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#004FE0",
                }}
              >
                {isResendButtonHidden
                  ? `(00:${countdown < 10 ? `0` : ``}${countdown})`
                  : `Resend Code`}
              </CTextButton>
            </Box>
          )}
        </Box>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default ConfirmationOTP;
